module.exports = __webpack_public_path__ + "img/photo-0045.ef5ece50.jpg";